import DrawerHybrid from "./DrawerHybrid";

/**
 * Drawer component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a `styled()` extension). The default export carries the
 * `.Header`, `.Content`, and `.CloseButton` statics.
 */
export { DrawerContext } from "./DrawerShared";
export default DrawerHybrid;
